"use strict";
exports.__esModule = true;
var report_option_tags_1 = require("../logic/report-option-tags");
angular.module("smartorg.r6.navs.reportOptions").directive("reportOptions", [function () {
        return {
            restrict: "E",
            template: require('../../template/report-options.html'),
            transclude: true,
            scope: {
                /**
                 * Toogle the highlighted node in tree.
                 */
                onToggleCompare: '&?',
                /**
                 * Set report options on workbench.
                 */
                onApplyReportOptions: '&?',
                onApplyOptionsChange: '&?'
            },
            link: function (scope) {
                scope.tags = new report_option_tags_1["default"].TagList();
                scope.groupTags = new report_option_tags_1["default"].TagList();
                scope.hidden = true; // Hide the main area
                scope.filter1Selected = undefined;
                scope.filter2Selected = undefined;
                // =====================================================
                // When functions are not passed in
                // =====================================================
                if (!scope.onToggleCompare) {
                    scope.onToggleCompare = function () {
                        return;
                    };
                }
                if (!scope.onApplyReportOptions) {
                    scope.onApplyReportOptions = function () {
                    };
                }
                if (!scope.onApplyOptionsChange) {
                    scope.onApplyOptionsChange = function () {
                    };
                }
                // =====================================================
                // The real deal
                // =====================================================
                /**
                 * Control the display of option panel.
                 *
                 * @param state {boolean} True: it is hidden now, show.
                 *     False: Hide.
                 */
                scope.toggleReportOptionPanel = function (state) {
                    scope.hidden = !state;
                    angular.element('#reportOptionCollapsePanel').collapse(scope.hidden ? "hide" : "show");
                    scope.$broadcast("report:header.toggle", {
                        show: scope.hidden
                    });
                };
                /**
                 * Show Advanced Filter Options
                 */
                scope.showAdvancedFilters = function () {
                    scope.getReportOptions();
                    if (scope.tags.tags) {
                        prepareForAdvancedFilterOptions();
                    }
                    angular.element("#advancedFiltersModal").modal({
                        backdrop: 'static', show: true
                    });
                };
                // clean it while writing code to handle complex queries
                var prepareForAdvancedFilterOptions = function () {
                    if (scope.basicFilterLogic) {
                        scope.categoryNamesFromBasicFilters = [];
                        var basicFilters = getFiltersFromFilterLogic(scope.basicFilterLogic);
                        for (var i = 0; i < basicFilters.length; i++) {
                            var split = basicFilters[i].split(":");
                            if (scope.categoryNamesFromBasicFilters.indexOf(split[0]) == -1) {
                                scope.categoryNamesFromBasicFilters.push(split[0]);
                            }
                        }
                        scope.categoryNames = scope.categoryNames.length == 0 ?
                            angular.copy(scope.categoryNamesFromBasicFilters) : scope.categoryNames;
                    }
                    if (scope.advancedFilterLogic !== '') {
                        scope.filters = getFiltersFromFilterLogic(scope.advancedFilterLogic);
                    }
                };
                var getFiltersFromFilterLogic = function (filterLogic) {
                    var filters = [];
                    var str = angular.copy(filterLogic);
                    str = str.replace(/[()]/g, '');
                    var filterArray = str.split(' ');
                    for (var i = 0; i < filterArray.length; i++) {
                        if (scope.allFilterTags.indexOf(filterArray[i]) !== -1) {
                            filters.push(filterArray[i]);
                        }
                    }
                    return filters;
                };
                scope.addToAdvancedFilter = function (filter) {
                    if (scope.allFilterTags.indexOf(filter) !== -1) {
                        var split = filter.split(":");
                        if (scope.categoryNames.indexOf(split[0]) == -1) {
                            scope.categoryNames.push(split[0]);
                        }
                        scope.filters.push(filter);
                        scope.filterSelection = undefined;
                        prepareAdvancedFilterLogic();
                    }
                };
                var prepareAdvancedFilterLogic = function () {
                    scope.advancedFilterLogic = "";
                    for (var i = 0; i < scope.categoryNames.length; i++) {
                        var count = 0;
                        if (i > 0) {
                            scope.advancedFilterLogic += " and ";
                        }
                        for (var j = 0; j < scope.filters.length; j++) {
                            var split = scope.filters[j].split(":");
                            if (split[0] == scope.categoryNames[i]) {
                                if (count == 0) {
                                    scope.advancedFilterLogic += "(" + scope.filters[j] + ")";
                                }
                                else {
                                    scope.advancedFilterLogic = stringSplice(scope.advancedFilterLogic.length - 1, 0, " or " + scope.filters[j], scope.advancedFilterLogic);
                                }
                                count++;
                            }
                        }
                    }
                };
                var stringSplice = function (idx, rem, str, logic) {
                    return logic.slice(0, idx) + str + logic.slice(idx + Math.abs(rem));
                };
                scope.setBasicFilterState = function () {
                    var initState = { filterLogic: scope.advancedFilterLogic };
                    scope.initFilterState(initState);
                };
                scope.showAddFilterButton = function () {
                    return (scope.filterSelection !== undefined) &&
                        (scope.allFilterTags.indexOf(scope.filterSelection) !== -1);
                };
                scope.clearAdvancedFilters = function () {
                    scope.advancedFilterLogic = "";
                    scope.filters = [];
                    scope.categoryNames = [];
                    scope.filter1Selected = undefined;
                    scope.filter2Selected = undefined;
                    scope.filterSelection = undefined;
                    scope.clearOptions(1);
                    scope.additionalFiltersMsg = undefined;
                    scope.basicFilterLogic = undefined;
                };
                /**
                 * Reset all options. (Clean up selection.)
                 */
                scope.clearOptions = function (level) {
                    if (level > 0) {
                        scope.expandUnassignedForGroupBy = false;
                        scope.groupByTag = undefined;
                        scope.colorByTag = undefined;
                        scope.filter1Selected = undefined;
                        scope.filter2Selected = undefined;
                        scope.tags.resetAllTags();
                        scope.groupTags.resetAllTags();
                        scope.$broadcast("report:compare.clear");
                        scope.onToggleCompare({ nodeId: undefined });
                    }
                    if (level > 1) {
                        scope.loadTags(undefined, undefined);
                    }
                    scope.$broadcast("report:header.update", {
                        data: {}
                    });
                };
                /**
                 * Reset options and apply;
                 */
                scope.resetOptions = function () {
                    scope.clearAdvancedFilters();
                    scope.clearOptions(1);
                    scope.applyReportOptions();
                    scope.toggleReportOptionPanel(false, true);
                };
                var getCategoryNameFromFilterLogic = function (splitFilterLogic) {
                    var categoryName = "";
                    var tmpFilterLogic = splitFilterLogic.replace(/[()]/g, '');
                    var tagsInTmpFilterLogic = tmpFilterLogic.split(" or ");
                    if (tagsInTmpFilterLogic[0]) {
                        var split = tagsInTmpFilterLogic[0].split(":");
                        categoryName = split[0];
                    }
                    return categoryName;
                };
                var matchNormalWithAdvancedFilterLogic = function (filterLogic) {
                    //TODO: rewrite to handle complex queries
                    var splitFilterLogic = filterLogic.split(" and ");
                    var splitAdvancedFilterLogic = scope.advancedFilterLogic.split(" and ");
                    var origSplitAdvancedFilterLogic = angular.copy(splitAdvancedFilterLogic);
                    if (splitFilterLogic[0] !== "") {
                        for (var i = 0; i < splitFilterLogic.length; i++) {
                            var categoryName = getCategoryNameFromFilterLogic(splitFilterLogic[i]);
                            var present = false;
                            for (var j = 0; j < splitAdvancedFilterLogic.length; j++) {
                                var advCategoryName = getCategoryNameFromFilterLogic(splitAdvancedFilterLogic[j]);
                                if (categoryName == advCategoryName) {
                                    present = true;
                                    break;
                                }
                                else if (!present && (splitAdvancedFilterLogic.length - 1 == j)) {
                                    origSplitAdvancedFilterLogic.splice(i, 0, splitFilterLogic[i]);
                                }
                            }
                        }
                    }
                    if (splitFilterLogic.length == 1 &&
                        splitFilterLogic[0] == "" &&
                        origSplitAdvancedFilterLogic[0] !== "" &&
                        origSplitAdvancedFilterLogic.length > 1) {
                        var advCategoryName1 = getCategoryNameFromFilterLogic(origSplitAdvancedFilterLogic[0]);
                        var advCategoryName2 = getCategoryNameFromFilterLogic(origSplitAdvancedFilterLogic[1]);
                        if (advCategoryName1 == scope.filter1Selected.name &&
                            scope.filter2Selected &&
                            advCategoryName2 == scope.filter2Selected.name) {
                            origSplitAdvancedFilterLogic.splice(0, 2);
                        }
                        else {
                            for (var i = 0; i < origSplitAdvancedFilterLogic.length; i++) {
                                var advCategoryName = getCategoryNameFromFilterLogic(origSplitAdvancedFilterLogic[i]);
                                if (advCategoryName == scope.filter1Selected.name ||
                                    advCategoryName == scope.filter2Selected.name) {
                                    origSplitAdvancedFilterLogic.splice(i, 1);
                                }
                            }
                        }
                    }
                    else {
                        for (var i = 0; i < splitAdvancedFilterLogic.length; i++) {
                            var advCategoryName = getCategoryNameFromFilterLogic(splitAdvancedFilterLogic[i]);
                            for (var j = 0; j < splitFilterLogic.length; j++) {
                                var categoryName = getCategoryNameFromFilterLogic(splitFilterLogic[j]);
                                if (advCategoryName == categoryName) {
                                    origSplitAdvancedFilterLogic[i] = splitFilterLogic[j];
                                }
                            }
                        }
                    }
                    splitAdvancedFilterLogic = angular.copy(origSplitAdvancedFilterLogic);
                    if (splitFilterLogic.length == 1 && scope.filter2Selected) {
                        var categoryName = getCategoryNameFromFilterLogic(splitFilterLogic[0]);
                        var filterToBeDeleted = "";
                        if (categoryName == scope.filter1Selected.name) {
                            filterToBeDeleted = scope.filter2Selected.name;
                        }
                        else if (categoryName == scope.filter2Selected.name) {
                            filterToBeDeleted = scope.filter1Selected.name;
                        }
                        for (var i = 0; i < splitAdvancedFilterLogic.length; i++) {
                            var advCategoryName = getCategoryNameFromFilterLogic(splitAdvancedFilterLogic[i]);
                            if (advCategoryName == filterToBeDeleted) {
                                origSplitAdvancedFilterLogic.splice(i, 1);
                                break;
                            }
                        }
                    }
                    return origSplitAdvancedFilterLogic.join(" and ");
                };
                /**
                 * Generate report option object.
                 *
                 * Example:
                 * {
                 *     filterLogic: "Region:US and Region:EU",
                 *     compareToNodeID: "nodeID",
                 *     groupByList: '["Region:US","Region:EU"]',
                 *     colorByList: '["Region:US","Region:EU"]'
                 * }
                 */
                scope.getReportOptions = function () {
                    var filterLogic;
                    var groupByList;
                    var colorByList;
                    if (!scope.advancedFilterLogic) {
                        scope.advancedFilterLogic = "";
                    }
                    if (!scope.isLeaf) {
                        var filters = new report_option_tags_1["default"].TagList([scope.filter1Selected, scope.filter2Selected]);
                        filterLogic = filters.toDisplayStringList();
                        if (scope.groupByTag) {
                            groupByList = JSON.stringify(scope.groupByTag.getEntries().map(function (entry) { return scope.groupByTag.getName() + ":" + entry.getName(); }));
                        }
                        if (scope.colorByTag) {
                            colorByList = JSON.stringify(scope.colorByTag.getEntries().map(function (entry) { return scope.colorByTag.getName() + ":" + entry.getName(); }));
                        }
                    }
                    var compareNode = scope.getCompareNodeInfo();
                    var options = {
                        expandUnassignedForGroupBy: scope.expandUnassignedForGroupBy,
                        filterLogic: filterLogic ? filterLogic : undefined,
                        compareToNodeID: compareNode ? compareNode['id'] : undefined,
                        compareToNodeName: compareNode ? compareNode['name'] : undefined,
                        groupByList: groupByList ? groupByList : undefined,
                        colorByList: colorByList ? colorByList : undefined,
                        groupKey: scope.groupByTag ? scope.groupByTag.getName() : undefined,
                        colorKey: scope.colorByTag ? scope.colorByTag.getName() : undefined
                    };
                    if (scope.advancedFilterLogic !== '') {
                        scope.advancedFilterLogic = matchNormalWithAdvancedFilterLogic(filterLogic);
                        options['filterLogic'] = scope.advancedFilterLogic;
                    }
                    else if (options['filterLogic'] !== undefined) {
                        scope.basicFilterLogic = angular.copy(options['filterLogic']);
                        scope.advancedFilterLogic = options['filterLogic'];
                    }
                    scope.$broadcast("report:header.update", {
                        data: options
                    });
                    return options;
                };
                /**
                 * Send report options to workbench for further report
                 * actions.
                 */
                scope.applyReportOptions = function () {
                    scope.onApplyReportOptions({
                        reportOptions: scope.getReportOptions()
                    });
                    scope.onApplyOptionsChange();
                    scope.toggleReportOptionPanel(false, false);
                };
                // =====================================================
                // Set init state
                // Load tags, set what is selected
                // =====================================================
                /**
                 * Load tags from array of tag strings. Also set the inital
                 * states of filters.
                 *
                 * @param tagArray {Array<string>} The input array, in a
                 *     form of: ["all", "test:entry1", "test:entry2"].
                 * @param initState {{}} Initial state of the directives.
                 */
                scope.loadTags = function (tagArray, initState) {
                    var tagList = new report_option_tags_1["default"].TagList();
                    scope.allFilterTags = angular.copy(tagArray);
                    if (scope.allFilterTags) {
                        var index = scope.allFilterTags.indexOf('all');
                        if (index > -1) {
                            scope.allFilterTags.splice(index, 1);
                        }
                    }
                    tagList.loadTagsFromStringArray(tagArray);
                    scope.tags = tagList;
                    scope.groupTags = new report_option_tags_1["default"].TagList(tagList.getTags());
                    scope.groupTags.insertTag("<Subnodes>");
                    scope.initFilterState(initState);
                    scope.$broadcast("LOAD_OPTION_FILTERS", {
                        "tags": scope.tags
                    });
                };
                /**
                 * Init group by, color by and compare to state when got
                 * something from url.
                 *
                 * @param initState {} Initial state, same format as
                 *     getReportOption output except with detail compare
                 *     node infomation.
                 */
                scope.initPanelState = function (initState) {
                    if (initState && Object.keys(initState).length) {
                        if (initState['node']) {
                            scope.$broadcast("report:compare.set", {
                                node: initState['node']
                            });
                        }
                        scope.groupByTag =
                            scope.groupTags.findFirstTag(initState['groupKey']);
                        scope.colorByTag =
                            scope.groupTags.findFirstTag(initState['colorKey']);
                        //TODO: implement for getting it from short url
                        //scope.expandUnassignedForGroupBy =
                    }
                };
                /**
                 * Initialize the filters directives.
                 *
                 * @param initState {{}} Initial state of the directives.
                 */
                scope.initFilterState = function (initState) {
                    if (initState && 'filterLogic' in initState && initState['filterLogic']) {
                        scope.advancedFilterLogic = initState.filterLogic;
                        scope.filter1Selected = undefined;
                        scope.filter2Selected = undefined;
                        scope.additionalFiltersMsg = undefined;
                        var filters = initState['filterLogic'].split(" and ");
                        for (var i = 0; i < filters.length; i++) {
                            var filterEntries = filters[i].replace(/[()]/g, '').split(" or ");
                            var filterName = filterEntries[0].split(':')[0];
                            filterEntries = filterEntries.map(function (item) {
                                return item.substring(item.indexOf(':') + 1);
                            });
                            var tag = scope.tags.findFirstTag(filterName);
                            if (tag) {
                                tag.selectEntriesByName(filterEntries);
                            }
                            if (i == 0) {
                                scope.filter1Selected = tag;
                            }
                            else if (!scope.filter2Selected && tag.name !== scope.filter1Selected.name) {
                                scope.filter2Selected = tag;
                            }
                            else if (!scope.additionalFiltersMsg &&
                                tag.name !== scope.filter1Selected.name &&
                                tag.name !== scope.filter2Selected.name) {
                                scope.additionalFiltersMsg = tag['name'] + "...";
                            }
                        }
                        if (scope.filter1Selected) {
                            if (filters.length == 1) {
                                scope.basicFilterLogic = filters[0];
                            }
                            else {
                                scope.basicFilterLogic = filters[0] + " and " + filters[1];
                            }
                        }
                    }
                    else {
                        scope.filters = [];
                        scope.advancedFilterLogic = "";
                        scope.filterSelection = undefined;
                        scope.categoryNames = [];
                    }
                };
                // =====================================================
                // Compare To
                // =====================================================
                /**
                 * Handle compare to data. Because we are using drag and
                 * drop for compare to now, it is hard to handle this in
                 * compare to directive.
                 *
                 * Or create a controller/service for compare to.
                 *
                 * @returns {{id: string, name: string}} Id is the tree
                 *     node id, name is the display name.
                 */
                scope.getCompareNodeInfo = function () {
                    // The copy id is compare:id
                    var compareArea = angular.element("#compareArea").children();
                    if (compareArea.length) {
                        if (compareArea[0].id && compareArea[0].id.length > 8) {
                            var id = compareArea[0].id.substring(8);
                            scope.onToggleCompare({ nodeId: id });
                            return {
                                id: compareArea[0].id.substring(8),
                                name: compareArea[0].innerText ?
                                    compareArea[0].innerText :
                                    compareArea[0].textContent
                            };
                        }
                    }
                    else {
                        scope.onToggleCompare({ nodeId: undefined });
                    }
                    return undefined;
                };
                // =====================================================
                // Listen
                // =====================================================
                /**
                 * When select different treenodes, different set of tags
                 * are available for report options.
                 */
                scope.$on('report:options.load', function (event, args) {
                    var initState = args.initState ? args.initState : undefined;
                    //
                    scope.loadTags(args.tagString, initState);
                    scope.initPanelState(initState);
                    scope.isLeaf = args.isLeaf;
                    if (initState.expandUnassignedForGroupBy) {
                        scope.expandUnassignedForGroupBy = initState.expandUnassignedForGroupBy;
                    }
                    scope.onApplyReportOptions({
                        reportOptions: scope.getReportOptions()
                    });
                    if (!scope.$$phase) {
                        scope.$apply();
                    }
                });
                /**
                 * Workbench broadcast to get report options, in case user
                 * did not apply report options.
                 */
                scope.$on('report:options.apply', function () {
                    scope.onApplyReportOptions({
                        reportOptions: scope.getReportOptions()
                    });
                });
                scope.$on('report:options.clear.1', function () {
                    scope.clearOptions(1);
                });
                scope.$on('report:options.clear.2', function () {
                    scope.clearOptions(2);
                });
                scope.$on('report:options.clear.compare', function () {
                    scope.$broadcast("report:compare.clear");
                    scope.onToggleCompare({ nodeId: undefined });
                    scope.$broadcast("report:header.update", {
                        data: scope.getReportOptions()
                    });
                });
                scope.$on('workbench:toggle-collapse:bottom', function (event, args) {
                    scope.toggleReportOptionPanel(!args.collapsed);
                });
            }
        };
    }]);
//# sourceMappingURL=report-options-directive.js.map


// WEBPACK FOOTER //
// ./app/widgets/navigation/report-options/app/js/plumbing/report-options-directive.js